import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { formatDate } from "../../util/formatDate";
import moment from "moment";
import { hasRole } from "../../util/utilFunction";

export const useStockIn = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [dataListBahan, setDataListBahan] = useState();
  const [dataListCrusher, setDataListCrusher] = useState();
  const [dataListPewarna, setDataListPewarna] = useState();
  const [dataLogBahanCrusher, setDataLogBahanCrusher] = useState();
  const [companyRequest, setCompanyRequest] = useState("");
  const [materialBahan, setMaterialBahan] = useState("BAKU");
  const [materialName, setMaterialName] = useState("");
  const [jumlahRequest, setJumlahRequest] = useState("");
  const [keteranganRequestStockIn, setKeteranganRequestStockIn] = useState("");
  const [popUpRequest, setPopUpRequest] = useState(false);
  const [popUpErrorRequest, setPopUpErrorRequest] = useState(false);
  const [isReload, setIsReload] = useState(false);

  const [statusBahan, setStatusBahan] = useState("Keluar");
  const [subMenuStockIn, setSubMenuStockIn] = useState("BahanBaku");
  const [filterDate, setFilterDate] = useState(formatDate);

  useEffect(() => {
    if (hasRole(dataUser, "ppic_admin", "ppic_user")) {
      setSubMenuStockIn("RiwayatBahanBaku");
      setStatusBahan("Masuk");
    }
  }, []);

  useEffect(() => {
    if (hasRole(dataUser, "warehouse_crusher")) {
      setSubMenuStockIn("Crusher");
    }
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListBahan`,
      { tim: dataUser.tim, role: dataUser.role },
      dataUser.auth,
      setDataListBahan,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListCrusher`,
      { tim: dataUser.tim },
      dataUser.auth,
      setDataListCrusher,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListPewarna`,
      { tim: dataUser.tim },
      dataUser.auth,
      setDataListPewarna,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLogBahanCrusher`,
      { tim: dataUser.tim, date: filterDate },
      dataUser.auth,
      setDataLogBahanCrusher,
      ""
    );
    setIsReload(false);
  }, [isReload, filterDate]);

  useEffect(() => {
    setCompanyRequest("");
    setMaterialName("");
    setJumlahRequest("");
    setKeteranganRequestStockIn("");
    if (hasRole(dataUser, "ppic_admin", "ppic_user", "super_user")) {
      setStatusBahan("Masuk");
    } else {
      setStatusBahan("Keluar");
    }
  }, [isReload, subMenuStockIn]);

  useEffect(() => {
    setMaterialName("");
  }, [companyRequest]);

  const validateNamaBahan = () => {
    let data;
    dataListBahan &&
      dataListBahan.forEach((obj) => {
        if (obj.company === companyRequest) {
          data = obj.data;
        }
      });
    return data;
  };
  const validateNamaCrusher = () => {
    let data;
    dataListCrusher &&
      dataListCrusher.forEach((obj) => {
        if (obj.company === companyRequest) {
          data = obj.data;
        }
      });
    return data;
  };
  const validateNamaPewarna = () => {
    let data;
    dataListPewarna &&
      dataListPewarna.forEach((obj) => {
        if (obj.company === companyRequest) {
          data = obj.data;
        }
      });
    return data;
  };

  useEffect(() => {
    validateNamaBahan();
  }, [companyRequest]);

  const dataBahan = validateNamaBahan();
  const dataCrusher = validateNamaCrusher();
  const dataPewarna = validateNamaPewarna();

  const handleSubmitRequest = (button) => {
    if (button === "OK") {
      setPopUpRequest(false);
      setPopUpErrorRequest(false);
    }
  };

  const handleFindBahan = () => {
    if (subMenuStockIn === "BahanBaku") {
      const data =
        dataBahan &&
        dataBahan.find((o) => (o.material === materialName ? o : ""));
      return data;
    } else if (subMenuStockIn === "Crusher") {
      const data =
        dataCrusher &&
        dataCrusher.find((o) => (o.material === materialName ? o : ""));
      return data;
    } else if (subMenuStockIn === "Pewarna") {
      const data =
        dataPewarna &&
        dataPewarna.find((o) => (o.material === materialName ? o : ""));
      return data;
    }
  };

  const findBahan = handleFindBahan();

  const handleKirimRequestIn = async () => {
    if (
      companyRequest !== "" &&
      materialBahan !== "" &&
      materialName !== "" &&
      jumlahRequest !== ""
    ) {
      setPopUpRequest(true);
      await postAxios(
        `${process.env.REACT_APP_ENDPOINT}/stockIn`,
        {
          company: companyRequest,
          role: dataUser.role,
          material: findBahan.material,
          jenisBahan: findBahan.jenis,
          total: Number(jumlahRequest),
          keterangan: keteranganRequestStockIn,
          updatedBy: dataUser.name,
          statusBahan: statusBahan,
          tim: dataUser.tim,
          type: subMenuStockIn,
          updateTime: moment().utcOffset("+0700").format(),
          masukTime: hasRole(dataUser, "ppic_user", "super_user")
            ? moment(filterDate).utcOffset("+0700").format()
            : moment().utcOffset("+0700").format(),
          month: moment().utcOffset("+0700").month() + 1,
        },
        dataUser.auth,
        "",
        ""
      );
      setIsReload(true);
      setCompanyRequest("");
      setMaterialName("");
      setJumlahRequest("");
      setKeteranganRequestStockIn("");
      setStatusBahan("Keluar");
    } else {
      setPopUpErrorRequest(true);
    }
  };

  return {
    dataUser,
    companyRequest,
    setCompanyRequest,
    setMaterialBahan,
    setMaterialName,
    handleSubmitRequest,
    dataBahan,
    popUpRequest,
    materialBahan,
    setPopUpRequest,
    jumlahRequest,
    setJumlahRequest,
    setKeteranganRequestStockIn,
    keteranganRequestStockIn,
    dataListBahan,
    handleKirimRequestIn,
    materialName,
    popUpErrorRequest,
    statusBahan,
    setStatusBahan,
    subMenuStockIn,
    setSubMenuStockIn,
    dataCrusher,
    dataLogBahanCrusher,
    filterDate,
    setFilterDate,
    dataPewarna,
  };
};
